<template>
  <h2>Favorieten</h2>
  <p class="light">Dit is een lijst met al jouw favoriete recepten.</p>

  <Spinner v-if="loading" />

  <div v-else>
  <BookmarksList
      v-if="bookmarks && bookmarks.length > 0"
      @updated='init()'
      :bookmarks="bookmarks"
  />

  <div class="cta-card" v-else>
    <h3>Je hebt geen favorieten!</h3>
    <p class="light">Je kun tijdens het lezen van een Broodje Dunner e-book rechts onderin op het hartje klikken om de huidige
      pagina hier op te slaan. Zo vind je jouw favoriete recepten altijd snel terug.</p>
    <router-link
        class="btn"
        :to="{name: 'pages.books'}"
    >
      Naar jouw boekenplank
    </router-link>
  </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import BookmarksList from "./bookmarks/BookmarksList.vue";
import Spinner from "../blocks/Spinner.vue";

export default {
  name: "Bookmarks",
  data() {
    return {
      bookmarks: [],
      loading: true,
    };
  },
  components: {
    BookmarksList,
    Spinner
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("bookmark", [
      "getBookmarks",
    ]),
    init() {
      this.getBookmarks().then(response => {
        this.bookmarks = response;
        this.loading = false;
      });
    },
  },
};
</script>
